/* Créations Colibri : collection et fiche attrape-soleil. Ajout au panier sans quitter la page (tiroir panier du thème), filtres, tri, galerie, barre d'achat. */
(function () {
  if (window.ccColibri) return;
  window.ccColibri = true;
  var routes = window.routes || {};
  function euros(c) { return (c / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €'; }
  function ajouter(id, btn) {
    if (!id) return;
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var html = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('ccx-charge'); }
    fetch(routes.cart_add_url || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { alert(data.description || data.message || 'Impossible d\'ajouter cet article.'); return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else { window.location.href = routes.cart_url || '/cart'; return; }
        if (btn) { btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:inline-block;vertical-align:-3px"><path d="M20 6 9 17l-5-5"/></svg> Ajouté'; setTimeout(function () { btn.innerHTML = html; }, 1800); }
        majLivraison();
      })
      .catch(function () { window.location.href = routes.cart_url || '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('ccx-charge'); } });
  }
  function majLivraison() {
    var box = document.querySelector('[data-ccx-seuil]');
    if (!box) return;
    fetch((routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) {
      var seuil = parseInt(box.getAttribute('data-ccx-seuil'), 10), reste = seuil - c.total_price;
      var txt = box.querySelector('[data-ccx-reste]'), j = box.querySelector('.ccx-jauge');
      if (txt) txt.textContent = reste > 0 ? 'plus que ' + euros(reste) + ' pour la livraison offerte' : 'livraison offerte';
      if (j) { j.hidden = false; j.querySelector('i').style.width = Math.min(100, Math.round(c.total_price * 100 / seuil)) + '%'; }
    });
  }
  function appliquer(root) {
    var actif = root.querySelector('.ccx-filtre.actif'), c = actif ? actif.getAttribute('data-cat') : 'tous';
    var tout = root.getAttribute('data-tout') === '1';
    var st = root.querySelector('[data-ccx-stock]'), stock = !!(st && st.checked);
    var prix = [].slice.call(root.querySelectorAll('[data-ccx-prix].actif')).map(function (b) { return b.getAttribute('data-ccx-prix').split('-').map(Number); });
    var tri = root.querySelector('.ccx-tri'), triDefaut = !tri || tri.value === 'rang';
    var libre = c === 'tous' && !stock && !prix.length, n = 0;
    root.querySelectorAll('.ccx-carte').forEach(function (k) {
      var cats = (k.getAttribute('data-cat') || '').split(' '), p = parseFloat(k.getAttribute('data-prix')) || 0;
      var ok = (c === 'tous' || cats.indexOf(c) > -1) && (!stock || !k.hasAttribute('data-epuise')) &&
        (!prix.length || prix.some(function (r) { return p >= r[0] && p <= r[1]; }));
      k.classList.toggle('ccx-cache', !(ok && (!libre || tout || !k.hasAttribute('data-plus'))));
      if (ok) n++;
    });
    root.querySelectorAll('.ccx-tuile').forEach(function (t) { t.hidden = !libre || !triDefaut; });
    var vp = root.querySelector('[data-ccx-voirplus]'); if (vp) vp.hidden = !libre || tout;
    var txt = n + (n > 1 ? ' modèles' : ' modèle');
    var nb = root.querySelector('[data-ccx-nb]'); if (nb) nb.textContent = txt;
    var vr = root.querySelector('[data-ccx-voir-resultats]'); if (vr) vr.textContent = n ? 'Voir les ' + txt : 'Aucun modèle';
    var vide = root.querySelector('[data-ccx-vide]'); if (vide) vide.hidden = n > 0;
    var nf = (stock ? 1 : 0) + prix.length, fb = root.querySelector('[data-ccx-filtrer] .nb'); if (fb) fb.textContent = nf ? ' (' + nf + ')' : '';
  }
  function filtrer(btn) {
    var root = btn.closest('.ccx-col'); if (!root) return;
    root.querySelectorAll('.ccx-filtre').forEach(function (x) { x.classList.toggle('actif', x === btn); x.setAttribute('aria-pressed', x === btn); });
    appliquer(root);
  }
  function toutAfficher(root) {
    root.setAttribute('data-tout', '1');
    appliquer(root);
  }
  function trier(sel) {
    var root = sel.closest('.ccx-col'), g = root.querySelector('.ccx-grille'), v = sel.value;
    var cartes = [].slice.call(g.querySelectorAll('.ccx-carte')), tuiles = [].slice.call(g.querySelectorAll('.ccx-tuile'));
    var n = function (k, a) { return parseFloat(k.getAttribute(a)) || 0; };
    var ep = function (k) { return k.hasAttribute('data-epuise') ? 1 : 0; };
    cartes.sort(function (a, b) {
      if (ep(a) !== ep(b)) return ep(a) - ep(b);
      if (v === 'prix-asc') return n(a, 'data-prix') - n(b, 'data-prix') || n(a, 'data-rang') - n(b, 'data-rang');
      if (v === 'prix-desc') return n(b, 'data-prix') - n(a, 'data-prix') || n(a, 'data-rang') - n(b, 'data-rang');
      if (v === 'recent') return n(b, 'data-cree') - n(a, 'data-cree');
      return n(a, 'data-rang') - n(b, 'data-rang');
    });
    cartes.forEach(function (k) {
      g.appendChild(k);
      if (v === 'rang') tuiles.forEach(function (t) { if (t.getAttribute('data-apres') === k.getAttribute('data-rang')) g.appendChild(t); });
    });
    if (v !== 'rang') root.setAttribute('data-tout', '1');
    appliquer(root);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ccx-ajout]');
    if (b) { e.preventDefault(); ajouter(b.getAttribute('data-ccx-ajout'), b); return; }
    var f = e.target.closest('.ccx-filtre');
    if (f) { filtrer(f); return; }
    var v = e.target.closest('[data-ccx-voirplus]');
    if (v) { toutAfficher(v.closest('.ccx-col')); return; }
    var fb = e.target.closest('[data-ccx-filtrer]');
    if (fb) {
      var pan = document.getElementById(fb.getAttribute('aria-controls')), ouvre = pan.hidden;
      pan.hidden = !ouvre; fb.setAttribute('aria-expanded', String(ouvre)); return;
    }
    var px = e.target.closest('[data-ccx-prix]');
    if (px) {
      var on = !px.classList.contains('actif');
      px.classList.toggle('actif', on); px.setAttribute('aria-pressed', String(on)); appliquer(px.closest('.ccx-col')); return;
    }
    var ef = e.target.closest('[data-ccx-effacer]');
    if (ef) {
      var re = ef.closest('.ccx-col');
      re.querySelectorAll('[data-ccx-prix]').forEach(function (x) { x.classList.remove('actif'); x.setAttribute('aria-pressed', 'false'); });
      var cs = re.querySelector('[data-ccx-stock]'); if (cs) cs.checked = false;
      appliquer(re); return;
    }
    var vr = e.target.closest('[data-ccx-voir-resultats]');
    if (vr) {
      var rv = vr.closest('.ccx-col'), pv = rv.querySelector('.ccx-panneau'), bv = rv.querySelector('[data-ccx-filtrer]');
      if (pv) pv.hidden = true; if (bv) bv.setAttribute('aria-expanded', 'false');
      rv.querySelector('.ccx-grille').scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
    }
    var a = e.target.closest('[data-ccx-tous-avis]');
    if (a) {
      var z = document.getElementById(a.getAttribute('aria-controls')), ouvrir = a.getAttribute('aria-expanded') !== 'true';
      if (!z) return;
      z.classList.toggle('ouvert', ouvrir);
      a.setAttribute('aria-expanded', String(ouvrir));
      a.textContent = a.getAttribute(ouvrir ? 'data-ouvert' : 'data-ferme');
      if (!ouvrir) a.scrollIntoView({ block: 'center' });
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('.ccx-tri')) { trier(e.target); return; }
    if (e.target.matches('[data-ccx-stock]')) { appliquer(e.target.closest('.ccx-col')); return; }
    if (e.target.matches('.ccx-form select[name=id]')) {
      var o = e.target.selectedOptions[0], cta = document.querySelector('[data-ccx-cta]'), b = document.querySelector('.ccx-barre [data-ccx-ajout]');
      if (cta && o) cta.textContent = 'Ajouter au panier · ' + o.getAttribute('data-prix');
      if (b) b.setAttribute('data-ccx-ajout', e.target.value);
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.ccx-form'); if (!form) return;
    e.preventDefault();
    ajouter(new FormData(form).get('id'), form.querySelector('[data-ccx-cta]'));
  });
  function videosDescription() {
    var vs = [].slice.call(document.querySelectorAll('[data-ccx-video] video'));
    if (!vs.length) return;
    var jouer = function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (!('IntersectionObserver' in window)) { vs.forEach(jouer); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) jouer(e.target); else e.target.pause(); });
    }, { rootMargin: '250px 0px' });
    vs.forEach(function (v) { v.muted = true; v.removeAttribute('controls'); io.observe(v); });
  }
  function barreFiltres(nav) {
    var b = nav.nextElementSibling; if (!b || !b.classList.contains('ccx-filtres-barre')) return;
    var i = b.firstElementChild;
    var maj = function () {
      var max = nav.scrollWidth - nav.clientWidth, w = nav.clientWidth / Math.max(nav.scrollWidth, 1);
      b.classList.toggle('inutile', max < 4);
      nav.classList.toggle('fin', nav.scrollLeft >= max - 4);
      i.style.width = (w * 100).toFixed(1) + '%';
      i.style.left = (max > 0 ? nav.scrollLeft / max * (1 - w) * 100 : 0).toFixed(1) + '%';
    };
    nav.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(maj);
    maj();
  }
  function init() {
    videosDescription();
    document.querySelectorAll('.ccx-filtres').forEach(barreFiltres);
    document.querySelectorAll('.ccx-col').forEach(appliquer);
    document.querySelectorAll('.ccx-defile').forEach(function (d) {
      var root = d.closest('.ccx-prod'), comp = root.querySelector('.ccx-compteur'), vig = [].slice.call(root.querySelectorAll('.ccx-vignette'));
      d.addEventListener('scroll', function () {
        var i = Math.round(d.scrollLeft / d.clientWidth);
        if (comp) comp.textContent = (i + 1) + ' / ' + d.children.length;
        vig.forEach(function (x, k) { x.classList.toggle('actif', k === i); });
      }, { passive: true });
      vig.forEach(function (x, k) { x.addEventListener('click', function () { d.scrollTo({ left: k * d.clientWidth, behavior: 'smooth' }); }); });
    });
    var cta = document.querySelector('[data-ccx-cta]'), barre = document.querySelector('.ccx-barre');
    if (cta && barre) {
      var maj = function () { barre.classList.toggle('visible', cta.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', maj, { passive: true }); maj();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
